import Dexie from "dexie";

export const db = new Dexie("dentmemo_v2");
db.version(1).stores({
  patients: "id, name, updated_at",
  visits: "id, patient_id, date, updated_at",
  consultants: "id, name",
  settlements: "id, consultant_id",
  queue: "++qid, entity, created_at",
  meta: "key",
});
// Treatment bills were tried on the test site and withdrawn. Version 2 added their tables and
// version 3 removes them, so browsers that opened the test build upgrade cleanly.
db.version(2).stores({
  bills: "id, patient_id, updated_at",
  payments: "id, bill_id, patient_id, updated_at",
});
db.version(3).stores({ bills: null, payments: null });

export const ENTITIES = ["patients", "visits", "consultants", "settlements"];

export async function cacheAll(entity, rows) {
  await db.table(entity).clear();
  if (rows?.length) await db.table(entity).bulkPut(rows);
}

export async function localRows(entity) {
  return db.table(entity).toArray();
}

export async function enqueue(entity, data, op = "upsert") {
  await db.table(entity).put(data);
  await db.queue.add({ entity, op, data, created_at: new Date().toISOString() });
}

export async function queueCount() {
  return db.queue.count();
}

export async function drainQueue(pushFn) {
  const items = await db.queue.toArray();
  if (!items.length) return { applied: 0 };
  const ops = items.map((i) => ({ entity: i.entity, op: i.op, data: i.data }));
  await pushFn(ops);
  await db.queue.bulkDelete(items.map((i) => i.qid));
  return { applied: items.length };
}
